<template>
   <!-- 选择logo -->
    <div class="setLogoBox">
      <div class="logoInfo">
        <div class="logoList scrollbar">
          <p class="titlInfo">{{ $t('lang.selectdisplayedLogo') }}</p>
          <p class="hintTitle">
            {{ $t('lang.imgTips', { key: `${VideoResolution.width}x${VideoResolution.height}`}) }}
          </p>
           <!-- 预览打开 -->
          <div class="perview" @click="OpenPreview">
            <i class="iconfont icon-preview_btn"></i>
            <span>{{$t('lang.CrawlPerview')}}</span>
          </div>
          <ul class="imgList" v-loading="loadedImg">
            <!-- 上传logo -->
            <li
              class="uploadWrap"
              v-loading="loadFlag">
              <p
                class="uploadBtn"
                v-if="!loadFlag"
                >+</p>
              <input
                :disabled="CloneDisabled.Logo||CloneDisabled.disableButton"
                type="file"
                class="file-select cursorPointer"
                ref="uploadFile"
                title=""
                :accept="imgAccept"
                name="file"
                id="uploadFile"
                @change="getFile($event)"
              />
            </li>
            <!-- logo列表 -->
            <li
              v-for="(item, index) in cities"
              :key="index"
              :class="{ 'OnPitch': item.logoSetOn }"
            >
              <img
                :src="item.url"
              />
              <p class="ImgName" :title="item.name">{{item.logoFileName}}</p>
              <p
                v-if="item.logoSetOn"
                class="SelectIcon">
                <i class="el-icon-upload-success el-icon-check"></i>
              </p>
              <div
                class="OperationWrap"
                v-if="!item.logoSetOn">
                <div class="wrap">
                  <i
                  :disabled="CloneDisabled.disableButton"
                    @click="deleteLogo(item, index)"
                    class="el-icon-delete el-icon-check"
                  ></i>
                  <span class="VerticalLine"></span>
                  <i
                  :disabled="CloneDisabled.disableButton"
                    @click="selectLogo(item, index)"
                    class="el-icon-upload-success el-icon-check"
                  ></i>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- logo位置 -->
        <div class="optionBox">
          <p class="positionTitle">{{ $t('lang.displayPosition') }}</p>
          <div class="CommonLocation">
            <el-radio v-model="SetIcon.custom" :label="0" @change="LogoTypeChange">{{$t('lang.CommonLocation')}}</el-radio>
            <div class="locationBox" v-if="SetIcon.custom == 0">
              <div
                :class="['angle1', { SeleteAngle: SetIcon.logoLocation == 1 }]"
                @click="SetlogoLocation(1)"
              ></div>
              <div
                :class="['angle2', { SeleteAngle: SetIcon.logoLocation == 2 }]"
                @click="SetlogoLocation(2)"
              ></div>
              <div
                :class="['angle3', { SeleteAngle: SetIcon.logoLocation == 3 }]"
                @click="SetlogoLocation(3)"
              ></div>
              <div
                :class="['angle4',{ SeleteAngle: SetIcon.logoLocation == 4 }]"
                @click="SetlogoLocation(4)"
              ></div>
            </div>
          </div>
          <div class="CustomLocation">
            <el-radio v-model="SetIcon.custom" :label="1" @change="LogoTypeChange">{{$t('lang.Custom')}}</el-radio>
            <div class="LocationSize" v-if="SetIcon.custom == 1">
              <div class="CoordinateWrap">
                <div class="CoordinateTitle">{{ $t('lang.Location') }}</div>
                <div class="CoordinateSet">
                  <p class="name">X</p>
                  <el-input
                    v-model.number="SetIcon.logoXOffset"
                    type="number"
                    @change="customImgPosition('x')"
                  ></el-input>
                </div>
                <div class="CoordinateSet">
                  <p class="name">Y</p>
                  <el-input
                    v-model.number="SetIcon.logoYOffset"
                    type="number"
                    @change="customImgPosition('y')"
                  ></el-input>
                </div>
              </div>
              <div class="CoordinateWrap">
                <div class="CoordinateTitle">{{ $t('lang.Dimension') }}</div>
                <div class="CoordinateSet">
                  <p class="name">{{ $t('lang.width') }}</p>
                  <el-input
                    v-model.number="SetIcon.logoWidth"
                    type="number"
                    @change="customImgPosition('w')"
                  ></el-input>
                </div>
                <div class="CoordinateSet">
                  <p class="name">{{ $t('lang.height') }}</p>
                  <el-input
                    v-model.number="SetIcon.logoHeight"
                    type="number"
                    @change="customImgPosition('h')"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <logo-preview v-if="previewObj.syncSwitch" :previewObj="previewObj" :VideoResolution="VideoResolution" @UpdateLocation="UpdateLocation"></logo-preview>
      <el-button :disabled="CloneDisabled.Logo||CloneDisabled.disableButton"  class="saveBtn" :loading="saveLoading" type="success" @click="saveInfo">{{ $t('lang.save') }}</el-button>
    </div>
</template>
<script>
import AWS from 'aws-sdk'
import { mapState } from 'vuex'
import Outil from '@/assets/js/utils.js'
import toTips from '@/assets/js/toTipsObj'
import { playoutAnalyze } from '@/assets/js/googleAnalyze/playout.js'
import LogoPreview from './Logo/LogoPreview.vue'
import commonRequest from '@/assets/js/common/commonRequest.js'

export default {
  props: {
    nativeInfo: {
      type: Object,
      default: () => ({
        logoOnFlag: false,
        CrawlOnFlag: false
      })
    },
    // R的信息
    fixedDevice: Object
  },
  components: {
    LogoPreview
  },
  computed: mapState({
    State: (state) => state,
    pageRequest: (state) => state.websocket.pageRequest,
    CloneDisabled: (state) => state.playout.CloneDisabled
  }),
  data () {
    return {
      // region bucket等信息
      RegionInfo: {},
      // 图标列表
      cities: [],
      loadedImg: false,
      imgAccept: '.jpg,.jpeg,.png,.gif', //   图片上传格式
      loadFlag: false, //   上传加载开关
      // 设置logo信息
      SetIcon: {
        logoId: '',
        logoFileUrl: '',
        custom: 1,
        logoLocation: 4,
        logoXOffset: 0,
        logoYOffset: 0,
        logoWidth: 1280,
        logoHeight: 720,
        aspectRatio: 1280 / 720
      },
      // 所选分辨率
      VideoResolution: {
        width: 1920,
        height: 1080,
        scaleRatio: 0.30833333333333335
      },
      // 固定位置初始坐标
      InitPosition: {
        x: 30,
        y: 30
      },
      userSessionId: '', // 拥有者session
      OwnerUserid: '', // Owner  id
      saveLoading: false,
      // 预览的信息
      previewObj: {
        syncSwitch: false
      },
      programId: ''
    }
  },
  watch: {
  },
  created () {
    this.RegionInfo = this.$BehaviorSyns.getRegionBucket()
    this.OwnerUserid = Outil.getProgramReceiver('ownerUserId')
    this.programId = this.$BehaviorSyns.getProgramId()
    // 获取所选分辨率
    commonRequest.getVideoResolution().then((res) => {
      if (res.width) {
        this.VideoResolution = {
          width: res.width,
          height: res.height,
          scaleRatio: 592 / res.width
        }
      }
      this.getLogoList()
      this.previewObj.syncSwitch = true
      this.ConvertDisplay()
    })
  },
  methods: {
    // 打开关闭预览
    OpenPreview () {
      if (!this.previewObj.syncSwitch) {
        this.previewObj.syncSwitch = true
        this.ConvertDisplay()
      }
    },
    // logo位置的两种模式
    LogoTypeChange () {
      if (this.SetIcon.custom == 0) {
        this.FixedPosition(this.SetIcon.logoLocation)
      }
      this.ConvertDisplay()
    },
    // 设置logo固定位置
    SetlogoLocation (key) {
      this.SetIcon.logoLocation = key
      this.FixedPosition(key)
      this.ConvertDisplay()
    },
    // 计算固定位置的坐标
    FixedPosition (key) {
      this.WidthHeightCheck()
      if (key == 1) {
        this.SetIcon.logoXOffset = this.VideoResolution.width - this.InitPosition.x - this.SetIcon.logoWidth
        this.SetIcon.logoYOffset = this.InitPosition.y
      } else if (key == 2) {
        this.SetIcon.logoXOffset = this.InitPosition.x
        this.SetIcon.logoYOffset = this.InitPosition.y
      } else if (key == 3) {
        this.SetIcon.logoXOffset = this.InitPosition.x
        this.SetIcon.logoYOffset = this.VideoResolution.height - this.InitPosition.y - this.SetIcon.logoHeight
      } else {
        this.SetIcon.logoXOffset = this.VideoResolution.width - this.InitPosition.x - this.SetIcon.logoWidth
        this.SetIcon.logoYOffset = this.VideoResolution.height - this.InitPosition.y - this.SetIcon.logoHeight
      }
    },
    // 固定位置校验
    WidthHeightCheck () {
      const XOffset = this.InitPosition.x + this.SetIcon.logoWidth - this.VideoResolution.width
      const YOffset = this.InitPosition.y + this.SetIcon.logoHeight - this.VideoResolution.height
      if (XOffset > 0 || YOffset > 0) {
        let changeType = 'w'
        if (XOffset > 0 && YOffset > 0) {
          const aspectRatio = XOffset / YOffset
          if (aspectRatio > this.SetIcon.aspectRatio) {
            changeType = 'w'
          } else {
            changeType = 'h'
          }
        } else if (XOffset > 0) {
          changeType = 'w'
        } else if (YOffset > 0) {
          changeType = 'h'
        }
        if (changeType == 'w') {
          this.SetIcon.logoWidth = this.VideoResolution.width - this.InitPosition.x
          this.SetIcon.logoHeight = Math.round(this.SetIcon.logoWidth / this.SetIcon.aspectRatio)
        } else {
          this.SetIcon.logoHeight = this.VideoResolution.height - this.InitPosition.y
          this.SetIcon.logoWidth = Math.round(this.SetIcon.logoHeight * this.SetIcon.aspectRatio)
        }
        this.$message.info(this.$t('lang.LogoOutRange'))
      }
    },
    // 自定义位置
    customImgPosition (key) {
      if (key == 'x') {
        this.SetIcon.logoXOffset = this.SetIcon.logoXOffset <= 0 ? 0 : this.SetIcon.logoXOffset
        if ((this.SetIcon.logoXOffset + this.SetIcon.logoWidth) > this.VideoResolution.width) {
          this.SetIcon.logoXOffset = this.VideoResolution.width - this.SetIcon.logoWidth
          this.$message.info(this.$t('lang.LogoOutRange'))
        }
      } else if (key == 'y') {
        this.SetIcon.logoYOffset = this.SetIcon.logoYOffset <= 0 ? 0 : this.SetIcon.logoYOffset
        if ((this.SetIcon.logoYOffset + this.SetIcon.logoHeight) > this.VideoResolution.height) {
          this.SetIcon.logoYOffset = this.VideoResolution.height - this.SetIcon.logoHeight
          this.$message.info(this.$t('lang.LogoOutRange'))
        }
      } else if (key == 'w' || key == 'h') {
        if (key == 'w') {
          this.SetIcon.logoWidth = this.SetIcon.logoWidth < 20 ? 20 : this.SetIcon.logoWidth
          this.SetIcon.logoHeight = this.SetIcon.logoWidth / this.SetIcon.aspectRatio
        }
        if (key == 'h') {
          this.SetIcon.logoHeight = this.SetIcon.logoHeight < 20 ? 20 : this.SetIcon.logoHeight
          this.SetIcon.logoWidth = this.SetIcon.logoHeight * this.SetIcon.aspectRatio
        }
        const XOffset = this.SetIcon.logoXOffset + this.SetIcon.logoWidth - this.VideoResolution.width
        const YOffset = this.SetIcon.logoYOffset + this.SetIcon.logoHeight - this.VideoResolution.height
        if (XOffset > 0 || YOffset > 0) {
          let changeType = 'w'
          if (XOffset > 0 && YOffset > 0) {
            const aspectRatio = XOffset / YOffset
            if (aspectRatio > this.SetIcon.aspectRatio) {
              changeType = 'w'
            } else {
              changeType = 'h'
            }
          } else if (XOffset > 0) {
            changeType = 'w'
          } else if (YOffset > 0) {
            changeType = 'h'
          }
          if (changeType == 'w') {
            this.SetIcon.logoWidth = this.VideoResolution.width - this.SetIcon.logoXOffset
            this.SetIcon.logoHeight = this.SetIcon.logoWidth / this.SetIcon.aspectRatio
          } else {
            this.SetIcon.logoHeight = this.VideoResolution.height - this.SetIcon.logoYOffset
            this.SetIcon.logoWidth = this.SetIcon.logoHeight * this.SetIcon.aspectRatio
          }
          this.$message.info(this.$t('lang.LogoOutRange'))
        }
      }
      this.ConvertDisplay()
    },
    // 转换显示
    ConvertDisplay () {
      this.previewObj = {
        ...this.previewObj,
        ...this.SetIcon
      }
    },
    // 更新位置
    UpdateLocation (Location) {
      this.SetIcon = {
        ...this.SetIcon,
        ...Location
      }
    },
    // 选择logo
    selectLogo (item) {
      if (this.CloneDisabled.disableButton) return
      this.cities.forEach(logo => {
        if (logo.logoId != item.logoId) {
          logo.logoSetOn = 0
        } else {
          logo.logoSetOn = 1
        }
      })
      this.SetIcon.logoId = item.logoId
      this.SetIcon.logoFileUrl = item.logoFileUrl
      this.SetIcon.custom = item.custom
      this.SetIcon.logoSetOn = item.logoSetOn
      this.SetIcon.logoLocation = item.logoLocation
      this.SetIcon.logoXOffset = item.logoXOffset > 0 ? item.logoXOffset : 0
      this.SetIcon.logoYOffset = item.logoYOffset > 0 ? item.logoYOffset : 0
      if (!item.logoWidth) {
        this.getImgSize(item).then(res => {
          if (res.type) {
            this.SetIcon.logoWidth = res.width
            this.SetIcon.logoHeight = res.height
            this.SetIcon.aspectRatio = this.SetIcon.logoWidth / this.SetIcon.logoHeight
            this.ConvertDisplay()
          } else {
            this.$message.warning(this.$t('lang.selectFileTips'))
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.SetIcon.logoWidth = item.logoWidth
        this.SetIcon.logoHeight = item.logoHeight
        this.SetIcon.aspectRatio = this.SetIcon.logoWidth / this.SetIcon.logoHeight
        this.ConvertDisplay()
      }
    },
    // 保存logo
    saveInfo () {
      playoutAnalyze('playoutSelectLogoSave', '/pop')
      if (this.SetIcon.logoId) {
        this.SelectLogoEnd()
      } else {
        this.$message({
          type: 'warning',
          message: this.$t('lang.selectLogo')
        })
      }
    },
    // 选择logo结束
    SelectLogoEnd () {
      this.saveLoading = true
      const params = JSON.parse(JSON.stringify(this.SetIcon))
      this.axios.post(Outil.getUrl('/logoTag/saveLogo'), params).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.getLogoList()
          this.$message({
            type: 'success',
            message: this.$t('lang.success')
          })
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
        this.saveLoading = false
      }).catch(() => {
        this.saveLoading = false
      })
    },
    // 获取图标
    getLogoList () {
      this.loadedImg = true
      this.axios.post(Outil.getUrl('/logoTag/getLogoList'), {
        programId: this.programId
      }).then((res) => {
        if (res.status == 200) {
          const { errorCode } = res.data
          if (errorCode === '0x0') {
            const list = res.data.result
            if (list.length > 0) {
              this.cities = []
              list.forEach((v) => {
                if (v.logoSetOn) {
                  this.selectLogo(v)
                }
                this.cities.push(v)
              })
            } else {
              this.cities = []
            }
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
          this.loadedImg = false
        }
      }).catch(() => {
        this.loadedImg = false
      })
    },
    // 判断图片是否有效
    getImgSize (item) {
      return new Promise((resolve, reject) => {
        const ImgObj = new Image()
        ImgObj.src = item.url
        const mapPictureSize = {}
        ImgObj.onload = function (res) {
          mapPictureSize.type = 1
          mapPictureSize.width = this.width
          mapPictureSize.height = this.height
          resolve(mapPictureSize)
        }
        ImgObj.onerror = function () {
          mapPictureSize.type = 0
          reject(mapPictureSize)
        }
      })
    },
    //   判断图片是否合格
    JudgmentConformity (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = function (evt) {
          const image = new Image()
          const mapPictureSize = {}
          image.onload = function () {
            mapPictureSize.type = 1
            mapPictureSize.width = this.width
            mapPictureSize.height = this.height
            resolve(mapPictureSize)
          }
          image.onerror = function () {
            mapPictureSize.type = 0
            reject(mapPictureSize)
          }
          image.src = evt.target.result
        }
        reader.readAsDataURL(file)
      })
    },
    // 上传图片
    async getFile (event) {
      this.loadFlag = true
      const { files } = event.target
      if (!files.length) {
        this.loadFlag = false
        this.$message.warning(this.$t('lang.selectFileTips'))
        return false
      }
      //   判断图片是否合格
      this.JudgmentConformity(files[0]).then((res) => {
        if (res.type) {
          if (res.width <= this.VideoResolution.width && res.height <= this.VideoResolution.height) {
            this.file = files[0]
            const ContentType = this.file.type ? this.file.type : null
            this.$http.post(
              '/file/request-upload-for-sdk',
              {
                region: this.RegionInfo.region,
                service: this.RegionInfo.ServerName,
                bucketId: this.RegionInfo.bucketId,
                directoryName: '/Images/Playout',
                fileName: this.file.name,
                userId: this.OwnerUserid
              },
              {
                requestBase: 'GATEWAY'
              }).then((obj) => {
              if (obj.data.errorCode == '0x0') {
                this.UploadAmazon(obj.data.result, ContentType)
              }
            })
          } else {
            this.loadFlag = false
            this.$message.warning(this.$t('lang.imgTips', { key: `${this.VideoResolution.width}x${this.VideoResolution.height}` }))
          }
        } else {
          this.$message.warning(this.$t('lang.selectFileTips'))
        }
      })
    },
    // 上传到亚马逊
    UploadAmazon (result, ContentType) {
      AWS.config.region = result.identityPoolRegion
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: result.identityPoolId
      })
      this.upload = new AWS.S3.ManagedUpload({
        params: {
          Bucket: result.bucket,
          Key: result.objectKey,
          Body: this.file,
          ACL: 'public-read',
          ContentType
        },
        service: new AWS.S3({
          region: result.region
        })
      })
      this.upload.on('httpUploadProgress', (event) => {
        // const process = Math.round((event.loaded * 100) / event.total);
      })
      this.upload.promise().then(
        (res) => {
          console.log(`${this.file.name} upload to S3 success!`, res)
          this.loadFlag = false
          // 添加到logo列表
          this.AddLogoList({
            bucketId: result.bucketId,
            directoryId: result.directoryId,
            objectKey: result.objectKey
          })
        },
        function (err) {
          this.loadFlag = false
          console.log(
            `There was an error uploading your photo: ${err.message}`
          )
        }
      )
    },
    // 添加logo到列表
    AddLogoList (params) {
      this.axios
        .post('/file/add-file', params, { requestBase: 'GATEWAY' })
        .then((res) => {
          const { errorCode } = res.data
          if (res.status == 200 && errorCode === '0x0') {
            this.getLogoList()
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
          } else {
            return false
          }
        }).catch(() => {})
    },
    // 删除logo
    deleteLogo (item) {
      if (this.CloneDisabled.disableButton) return
      this.axios
        .post(Outil.getUrl('/logoTag/logoUsed'), {
          logoId: item.id
        })
        .then((res) => {
          if (res.data.errorCode === '0x0') {
            const result = res.data.result || {}
            const programTemplates = result.programTemplates ? result.programTemplates.length : 0
            const scheduleTemplates = result.scheduleTemplates ? result.scheduleTemplates.length : 0
            const secondaryEvents = result.secondaryEvents ? result.secondaryEvents.length : 0
            const programs = result.programs ? result.programs.length : 0
            if (programTemplates + scheduleTemplates + secondaryEvents + programs) {
              this.$emit('ShowUsageDetails', result)
            } else {
              this.axios.post(Outil.getUrl('/logoTag/deleteLogo'), {
                programId: this.programId,
                logoId: item.logoId
              }).then((obj) => {
                if (obj.data.errorCode === '0x0') {
                  this.getLogoList()
                  this.$message({
                    type: 'success',
                    message: this.$t('lang.success')
                  })
                } else {
                  const errorInfo = this.$t(toTips[obj.data.errorCode]) || obj.data.errorInfo
                  this.$message.error(errorInfo)
                }
              })
            }
          }
        }).catch(() => {})
    }
  },
  beforeDestroy () {
  }
}
</script>
<style lang="less" scoped>
.setLogoBox {
  height: 100%;
  text-align: left;
  font-size: 16px;
  position: relative;
  .logoInfo {
    height: calc(100% - 35px);
    overflow-y: scroll;
    padding: 5px 0 10px;
  }
  .saveBtn {
    width: 100%;
    height: 32px;
    line-height: 32px;
    padding: 0;
  }
  .scrollbar {
    overflow-x: hidden;
  }
  .logoList {
    height: 205px;
    border-bottom: 1px solid #444;
    padding: 5px 0;
    position: relative;
    .titlInfo {
      font-size: 14px;
      color: #dbdbdb;
      margin-bottom: 0;
    }
    .hintTitle {
      font-size: 12px;
      color: #666666;
      margin: 0 0 5px 0;
    }
    .perview {
      position: absolute;
      right: 7px;
      top: 5px;
      color: #DBDBDB;
      font-size: 14px;
      i{
        font-size: 12px;
        margin-right: 5px;
      }
    }
    .imgList {
      display: flex;
      flex-wrap: wrap;
      .uploadWrap {
        width: 72px;
        height: 72px;
        margin-right: 5px;
        margin-bottom: 4px;
        position: relative;
        ::v-deep .el-loading-mask {
          opacity: 1;
        }
        .uploadBtn {
          width: 70px;
          height: 70px;
          border: 1px solid #666;
          line-height: 60px;
          text-align: center;
          cursor: pointer;
          font-size: 20px;
          margin: 0;
        }

        .file-select {
          opacity: 0;
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          width: 70px;
          height: 70px;
          cursor: pointer;
        }
      }
      li {
        position: relative;
        margin-right: 4px;
        margin-bottom: 4px;
        border: 1px solid transparent;
        overflow: hidden;
        img {
          width: 70px;
          height: 70px;
          object-fit: contain;
          display: block;
        }
        .ImgName{
          width: 70px;
          height: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 12px;
          margin: 0;
          background: rgba(0, 0, 0, .5);
          position: absolute;
          left: 0;
          bottom: 0;
          z-index: 1;
        }
        .SelectIcon {
          position: absolute;
          top: 0;
          right: 0;
          width: 20px;
          height: 20px;
          i {
            position: absolute;
            top: -1px;
            left: 8px;
            z-index: 100;
            font-size: 10px;
          }
        }
        .SelectIcon::after {
          content: "";
          width: 30px;
          height: 25px;
          background: #33ab4f;
          position: absolute;
          top: -13px;
          right: -13px;
          transform: rotate(45deg);
          z-index: 10;
        }
        .OperationWrap {
          width: 70px;
          height: 70px;
          background: rgba(0, 0, 0, 0.5);
          position: absolute;
          top: 0;
          left: 0;
          display: none;
          text-align: center;
          line-height: 70px;
          .wrap {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 25px;
          }
          .VerticalLine {
            display: inline-block;
            width: 1px;
            height: 16px;
            background: #eeeeee;
            margin: auto 6px;
          }
          i {
            font-size: 14px;
          }
        }
      }
      li:hover .OperationWrap {
        display: block;
      }
      .OnPitch {
        border: 1px solid #33ab4f;
        margin-right: 3px;
        margin-bottom: 4px;
      }
    }
  }
  .optionBox {
    .positionTitle {
      height: 17px;
      font-size: 14px;
      color: #dbdbdb;
      margin: 0;
    }
    ::v-deep .CommonLocation {
      margin-top: 10px;
      .el-radio__label {
        color: #DBDBDB;
      }
      .locationBox {
        width: 167px;
        height: 94px;
        background: #333333;
        border-radius: 2px;
        margin-left: 25px;
        position: relative;
        div {
          width: 24px;
          height: 13px;
          background: #333333;
          border: 1px solid #666666;
        }
        .angle1 {
          position: absolute;
          top: 8px;
          right: 7px;
        }
        .angle2 {
          position: absolute;
          top: 8px;
          left: 7px;
        }
        .angle3 {
          position: absolute;
          bottom: 8px;
          left: 7px;
        }
        .angle4 {
          position: absolute;
          bottom: 8px;
          right: 7px;
        }
        .SeleteAngle {
          border: 1px solid #33ab4f;
        }
      }
    }
    ::v-deep .CustomLocation {
      margin-top: 10px;
      .el-radio__label {
        color: #DBDBDB;
      }
      .LocationSize {
        .CoordinateWrap {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          margin-left: 25px;
          padding-right: 5px;
          .CoordinateTitle {
            width: 74px;
            font-size: 14px;
            color: #DBDBDB;
          }
          .CoordinateSet {
            width: calc(50% - 40px);
            padding-left: 15px;
            display: flex;
            align-items: center;
            .name {
              color: #777777;
              font-size: 14px;
              width: 45%;
              margin: 0;
              text-align: right;
              padding-right: 10px;
            }
            .el-input__inner {
              height: 32px;
              color: #fff;
              border: 0;
              border-radius: 2px;
              background-color: #313436;
              padding: 0 10px;
            }
          }
        }
      }
    }
  }
}
.BottomOperation {
  display: flex;
  justify-content: flex-end;
  height: 36px;
  margin-top: 24px;
  ::v-deep .el-button--info {
    width: 100px;
    height: 36px;
    background: #cccccc;
    border-radius: 4px;
    line-height: 36px;
    padding: 0;
    font-size: 14px;
    color: #333333;
  }
  ::v-deep .el-button--success {
    width: 100px;
    height: 36px;
    background: #00cc66;
    border-radius: 4px;
    border: 1px solid #0f620a;
    line-height: 36px;
    padding: 0;
    font-size: 14px;
    color: #ffffff;
  }
}
</style>
